import '@/styles/index.less';

import init from '../initSPA';

import Ocr from './IdCardOcr.vue';

const routes = [
  {
    path: '/',
    component: Ocr,
    meta: {
      title: '身份验证'
    }
  }
];

init(routes);
